<span>{{ typeWriterText$ | async }}</span>
<span class="typed-cursor ml-1" [class.hide-cursor]="hideCursorAfterComplete()"
  >&#95;</span
>
